import { createSlice } from '@reduxjs/toolkit';
import Push from "push.js";
export const createBrowserNotification = () => {
    Push.create('SubTrux', {
        body: 'You have new notifications',
        icon: 'assets/images/subtrux-logo-no-text.png',
        requireInteraction: true,
        onClick: function () {
            window.focus();
            // TODO
            // @ts-ignore
            this.close();
        }
    })
        .then(r => { })
        .catch(e => console.error(e));
};
const initialState = {
    items: []
};
export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        notificationDismiss: (state, action) => {
            state.items = state.items?.filter((item) => item.id !== action.payload);
        },
        notificationFetch: (state, action) => {
            if (action.payload.length > (state.items?.length ?? 0)) {
                createBrowserNotification();
            }
            return {
                ...state,
                items: action.payload
            };
        }
    }
});
export const { notificationDismiss, notificationFetch } = notificationSlice.actions;
export const notificationCountSelector = (state) => state?.notification?.items?.length ?? 0;
export const notificationsSelector = (state) => state?.notification?.items ?? [];
export default notificationSlice.reducer;
